<section class="panel">
    <div class="filters">
        <label
            >Associação
            <select [(ngModel)]="tenantId" (change)="load()">
                <option value="">Todas</option>
                @for (t of tenants; track t) {
                <option [value]="t">{{ t }}</option>
                }
            </select>
        </label>
        <label
            >Tipo
            <select [(ngModel)]="kind" (change)="load()">
                <option value="">Todos</option>
                <option value="fetch">Busca</option>
                <option value="submit">Envio</option>
            </select>
        </label>
        <label
            >Período
            <select [(ngModel)]="days" (change)="load()">
                <option value="1">Últimas 24 h</option>
                <option value="7">Últimos 7 dias</option>
                <option value="30">Últimos 30 dias</option>
                <option value="">Tudo</option>
            </select>
        </label>
        <label class="check"
            ><input type="checkbox" [(ngModel)]="onlyFailed" (change)="load()" /> Só com falha</label
        >
        <button mat-stroked-button (click)="load()" [disabled]="state === 'loading'">Atualizar</button>
    </div>

    @if (state === 'loading') {
    <div class="center"><mat-spinner diameter="32"></mat-spinner></div>
    } @else if (state === 'error') {
    <div class="center">
        <p>Não foi possível carregar os lotes.</p>
        <button mat-stroked-button (click)="load()">Tentar novamente</button>
    </div>
    } @else if (!items.length) {
    <div class="center">Nenhum lote com esses filtros.</div>
    } @else {
    <ul class="list">
        @for (l of items; track l.id) {
        <li>
            <button type="button" class="row" (click)="toggle(l)" [attr.aria-expanded]="openId === l.id">
                <span class="badge" [attr.data-failed]="l.failed">{{ l.failed ? 'Com falha' : l.end ? 'Ok' : 'Em andamento' }}</span>
                <b>{{ kindLabel(l) }}</b>
                <span class="muted">{{ l.tenantId || 'sem associação' }}</span>
                <span class="muted">{{ l.start | date: 'dd/MM HH:mm:ss' }}</span>
                <span class="muted">{{ duration(l) }}</span>
            </button>
            @if (openId === l.id) {
            <div class="detail">
                @if (l.producerId) {
                <p class="muted">Produtor: {{ l.producerId }}</p>
                } @if (l.mirrorDetail) {
                <p class="muted">Espelho: {{ l.mirrorDetail }}</p>
                }
                <label class="check"
                    ><input type="checkbox" [checked]="onlyFailedLogs" (change)="toggleOnlyFailedLogs()" /> Só logs com falha</label
                >
                @if (logsState === 'loading') {
                <mat-spinner diameter="20"></mat-spinner>
                } @else if (logsState === 'error') {
                <p>Falha ao carregar os logs do lote.</p>
                <button mat-stroked-button (click)="loadLogs()">Tentar novamente</button>
                } @else if (!logs.length) {
                <p class="muted">Nenhum log neste lote.</p>
                } @else {
                <ul class="logs">
                    @for (g of logs; track g.id) {
                    <li [attr.data-ok]="g.ok">
                        <span class="badge" [attr.data-failed]="!g.ok">{{ g.ok ? 'Ok' : 'Falha' }}</span>
                        <b>{{ g.entity || '—' }}</b>
                        <span class="muted">{{ g.entityId || '' }}</span>
                        <span class="muted">{{ g.start | date: 'HH:mm:ss' }}</span>
                        @if (g.error) {
                        <span class="err">{{ g.error }}</span>
                        } @if (g.correlationId) {
                        <span class="muted">corr. {{ g.correlationId }}</span>
                        }
                    </li>
                    }
                </ul>
                }
            </div>
            }
        </li>
        }
    </ul>
    }
</section>
